let BASE_URL = "";

export const LOGIN_ENDPOINT = `${BASE_URL}/api/v2/user/login`;
export const SIGNUP_ENDPOINT = `${BASE_URL}/api/v2/user/signup`;
export const GET_ALL_FILTER = `${BASE_URL}/api/v2/get_filters`;
export const GET_ALL_PACS_CONFIG = `${BASE_URL}/api/v2/get_pacs_configurations`;
export const GET_ALL_PACS = `${BASE_URL}/api/v2/get_pacs`;
export const GET_ALL_PLATFORM = `${BASE_URL}/api/v2/get_platform_configs`;
export const GET_ALL_TIMEZONES = `${BASE_URL}/api/v2/get_timezones`;
export const ADD_PACS = `${BASE_URL}/api/v2/add_pacs`;
export const ADD_PLATFORM_CONFIG = `${BASE_URL}/api/v2/add_platform_config`;
export const UPDATE_PLATFORM_CONFIG = `${BASE_URL}/api/v2/set_current_config/update_platform_config`;
export const GET_ALL_CONFIGS = `${BASE_URL}/api/v2/get_all_config`;
export const ADD_CONFIGS = `${BASE_URL}/api/v2/add_router_config`;
export const GET_ANON_PROTOCOLS = `${BASE_URL}/api/v2/get_anon_protocols`;
export const GET_STUDY_LEVEL_LOGS = `${BASE_URL}/api/v2/get_study_level_logs`;
export const GET_SOP_LEVEL_LOGS = `${BASE_URL}/api/v2/get_sop_level_logs`;
export const GET_DICOM_TAGS = `${BASE_URL}/api/v2/get_dicom_tags`;
export const ADD_ANON_PROTOCOL = `${BASE_URL}/api/v2/add_anon_protocol`;
export const ADD_FILTER = `${BASE_URL}/api/v2/add_filter`;
export const ADD_PACS_CONFIG = `${BASE_URL}/api/v2/add_pacs_config`;
export const SET_CURRENT_CONFIG = `${BASE_URL}/api/v2/set_current_config`;
export const DELETE_PACS = `${BASE_URL}/api/v2/delete_pacs`;
export const DELETE_FILTER = `${BASE_URL}/api/v2/delete_filter`;
export const DELETE_ANON_PROTOCOL = `${BASE_URL}/api/v2/delete_anon_protocol`;
export const DELETE_PACS_CONFIG = `${BASE_URL}/api/v2/delete_pacs_config`;
export const DELETE_PLATFORM_CONFIG = `${BASE_URL}/api/v2/delete_platform_config`;
export const DELETE_ROUTER_CONFIG = `${BASE_URL}/api/v2/delete_router_config`;
export const UPDATE_PACS = `${BASE_URL}/api/v2/update_pacs`;
export const UPDATE_FILTER = `${BASE_URL}/api/v2/update_filter`;
export const UPDATE_CUSTOM_FILTER = `${BASE_URL}/api/v2/add_dicom_tags_to_filter`;
export const UPDATE_PLATFORM = `${BASE_URL}/api/v2/update_platform_config`;
export const UPDATE_PACS_CONFIG = `${BASE_URL}/api/v2/update_pacs_config`;
export const UPDATE_ANON_PROTOCOL = `${BASE_URL}/api/v2/update_anon_protocol`;
export const UPDATE_ROUTER_CONFIG = `${BASE_URL}/api/v2/update_router_config`;
export const ADD_NEW_DICOM_TAG = `${BASE_URL}/api/v2/add_new_dicom_tag`;
export const GET_TAG_TO_FILTER = `${BASE_URL}/api/v2/get_tags_to_filter`;
export const GET_SOP_HEADERS = `${BASE_URL}/api/v2/get_sop_headers`;
export const GET_STUDY_HEADERS = `${BASE_URL}/api/v2/get_study_headers`;
export const GET_VERSION = `${BASE_URL}/api/v2/get_current_version`;
export const PING_ENDPOINT = `${BASE_URL}/api/v2/ping_platform`;
export const ECHO_ENDPOINT = `${BASE_URL}/api/v2/echo_pacs`;
export const DELETE_STUDY_LOGS = `${BASE_URL}/api/v2/delete_study_level_logs`;
export const GET_ALL_FETCHED_STUDIES = `${BASE_URL}/api/v2/get_qr_stats`;
export const DOWNLOAD_CSV_TEMPLATE = `${BASE_URL}/api/v2/qr_template`;
export const UPLOAD_CSV = `${BASE_URL}/api/v2/upload_qr_details`;
export const DOWNLOAD_STUDY_LEVEL_LOGS = `${BASE_URL}/api/v2/download_study_level_logs`;
export const GET_WORKFLOW_DATA = `${BASE_URL}/api/v2/get_router_config_flow`;
export const SET_WORKFLOW_DATA = `${BASE_URL}/api/v2/set_workflow_data`;
export const GET_WORKFLOW_FILTER = `${BASE_URL}/api/v2/get_workflow_filter`;
export const GET_WORKFLOW_PROTOCOL = `${BASE_URL}/api/v2/get_workflow_protocol`;
export const BASE_URL_AXIOS = BASE_URL;

//HL7 apis
export const ADD_HL7_NODE = `${BASE_URL}/api/v2/add_new_hl7_node`;
export const GET_HL7_VERSIONS = `${BASE_URL}/api/v2/get_hl7_versions`;
export const GET_HL7_NODES = `${BASE_URL}/api/v2/get_hl7_nodes`;
export const DELETE_HL7_NODE = `${BASE_URL}/api/v2/delete_hl7_node`;
export const UPDATE_HL7_NODE = `${BASE_URL}/api/v2/update_hl7_node`;
export const ADD_HL7_CONFIG = `${BASE_URL}/api/v2/add_new_hl7_config`;
export const UPDATE_HL7_CONFIG = `${BASE_URL}/api/v2/update_hl7_config`;
export const GET_HL7_CONFIG = `${BASE_URL}/api/v2/get_hl7_configs`;
export const GET_PUSHBACK_OPERATIONS = `${BASE_URL}/api/v2/get_hl7_pushback_operations`;
export const UPDATE_CURRENT_STATUS_HL7_CONFIG = `${BASE_URL}/api/v2/set_current_hl7_config`;

export const GET_STUDY_DIFF_DATA = `${BASE_URL}/api/v2/get_difference_json`;

//Login pAge

export const RESET_PASSWORD = `${BASE_URL}/api/v2/user/reset_password`;
export const SETTINGS_CONFIG = `${BASE_URL}/api/v2/retention_data`;

//Service Account

export const ADD_SERVICE_ACCOUNT = `${BASE_URL}/api/v2/save_service_account`;
export const GET_SERVICE_ACCOUNT = `${BASE_URL}/api/v2/get_service_account`;
export const DELETE_SERVICE_ACCOUNT = `${BASE_URL}/api/v2/delete_service_account`;
